module.exports = __webpack_public_path__ + "img/oie-trygg-ehandel-liggande-large.png";